const trafo = {
  get_diversity_data: "/api/powerdata/ADMD_DataExtraction",
  get_life_lost_data: "/api/powerdata/lossOfLife",
  get_assets_data: "/api/powerdata/device?num_days=${data.num_days}",
  get_ber_data: "/api/powerdata/ber/device/${data.areaId}",
  get_message_list: "/api/powerdata/messages/device/${data.device_id}",
  get_evbasedata: "/api/powerdata/evbasedata/device/${data.device_id}",
  update_assets_details: "/api/powerdata/device/${data.DeviceID}",
  get_assets_overview: "/api/powerdata/device/stats/${data.duration}",
  get_comparsion_data_chart: "/api/powerdata/device/chartdata/${data.id}",
  get_chart_data: "/api/powerdata/device/intchartdata/${data.id}",
  get_evm_list: "/api/powerdata/evmodellist",
  get_hpm_list: "/api/powerdata/hpmodellist",
  get_evm_hpm_combined_data: "/api/powerdata/modelanalysis/${data.id}",
  get_evm_data: "/api/powerdata/evmodelanalysis/${data.id}",
  get_evm_fleetanalysis: "/api/powerdata/model_fleetanalysis/${data.id_ev}/${data.id_hp}",
  get_chart_stats: "/api/powerdata/device/totalstats/${data.duration}",
  get_alerts_data: "/api/alert/powerdata",
  get_active_alerts: "/api/alert/powerdata/active",
  add_alert: "/api/alert/powerdata",
  update_alert: "/api/alert/powerdata/${data.id}",
  delete_alert: "/api/alert/${data.id}",
  get_recipients_list: "/api/alert/recipients/",
  add_recipient: "/api/alert/recipients/${data.id}",
  delete_recipient: "/api/alert/recipients/${data.alert_id}/${data.recipient_id}",
};

const weather = {
  fetch_ambient_temp_data: "/api/weather/temperatures",
};

export { trafo, weather };
